import dayjs from 'dayjs';

import { AppRoutes } from '@/router/routes';

import { BookingType } from '@/shared/types/bookingObjects.types';

export const TODAY = dayjs();

export const BOOKING_TYPES: BookingType[] = ['work_place', 'parking_place', 'meeting_room'];

export const MODERATOR_PASS_KIND = 'virtual';

export const USER_ROUTES = [
	{
		value: '/',
		label: 'Главная',
	},
	{
		value: AppRoutes.Bookings,
		label: 'Мои бронирования',
	},
	// {
	// 	value: AppRoutes.Favorites,
	// 	label: 'Избранное',
	// 	disabled: true,
	// },
	{
		value: AppRoutes.Rating,
		label: 'Рейтинг',
	},
	{
		value: AppRoutes.Help,
		label: 'Помощь',
	},
	{
		value: AppRoutes.About,
		label: 'О системе',
	},
];
